import { Link } from '@tanstack/react-router'

import { usePathHelper } from '@/hooks/usePathHelper'
import { cn } from '@/lib/utils'

import { getDeliveryRouteOrderLabel } from './delivery-share.utils'

export default function DeliveryRouteOrderLink({
  className,
  children,
  order,
  searchParams,
  ...props
}) {
  const path = usePathHelper()
  const orderPath = path.salesOrders.show(order.id)
  const orderLink = searchParams ? orderPath.search(searchParams).link : orderPath.link

  return (
    <Link
      {...orderLink}
      className={cn(
        'inline-flex items-center rounded-sm underline-offset-4 transition-colors hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60',
        className
      )}
      {...props}
    >
      {children ?? getDeliveryRouteOrderLabel(order)}
    </Link>
  )
}
